import _ from "lodash";
import $ from "jquery";
import { useEffect, useState } from "react";
import {
  Button,
  Dropdown,
  DropdownItemProps,
  DropdownProps,
  Form,
  FormProps,
  Input,
  Modal,
  Segment,
  Table,
  TextArea,
} from "semantic-ui-react";
import { dialogControl } from "../../controls/dialog-control";
import { useCurrentUser } from "../../hooks/auth-hook";
import { ModalControlData, useModalControl } from "../../hooks/commonHooks";
import { useFormConnect, useFormData } from "../../hooks/formHooks";
import { restRequest } from "../../http";
import { PageData } from "../../models/common_model";
import { ModelData } from "../../models/rma_tracking_model";
import { fieldError } from "../../utils";
import { Page } from "./Page";
import { JournalizationComponent } from "./JournalizationComponent";
import { notificationControl } from "../../controls/notification-control";

export function ProductionModelComponent(props: { area_id: number }) {
  const currentUser = useCurrentUser();
  const [searchData, setSearchField] = useFormData<any>({});
  const [models, setSearchData] = useFormConnect<any, PageData<ModelData>>(
    {},
    "commons/production_models/" + props.area_id + "/search"
  );

  const editModalControl = useModalControl();
  const journalizationModalControl = useModalControl(0);
  const [currentEditId, setCurrentEditId] = useState<number>();
  const [reloadNumber, setReloadNumber] = useState(0);

  return (
    <>
      <Segment.Group>
        <Segment attached="top">
          <Form
            onSubmit={(e) => {
              e.stopPropagation();
              setSearchData(searchData);
            }}
          >
            <Form.Group>
              <Form.Field inline>
                <Input
                  placeholder="Name"
                  name="name"
                  value={searchData["name"] || ""}
                  onChange={setSearchField}
                />
              </Form.Field>
              <div>
                <Button icon="search" type="submit"></Button>
              </div>
            </Form.Group>
          </Form>
        </Segment>
        <Segment attached="bottom">
          <Table striped>
            <Table.Header>
              <Table.Row>
                <th>Name</th>
                <th>Description</th>
                <th>
                  {currentUser.permissions.commons.production_model.create && (
                    <Button
                      color="blue"
                      icon="add"
                      content="Model"
                      size="mini"
                      onClick={(e) => {
                        setCurrentEditId(undefined);
                        editModalControl.setOpen(true);
                      }}
                    />
                  )}
                </th>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {models?.items.map((model) => {
                return (
                  <tr key={model.id}>
                    <td>{model.name}</td>
                    <td>{model.description}</td>
                    <td>
                      {currentUser.permissions.commons.production_model
                        .update && (
                        <Button
                          onClick={(e) => {
                            setCurrentEditId(model.id);
                            editModalControl.setOpen(true);
                          }}
                          color="blue"
                          icon="edit"
                          size="mini"
                        />
                      )}

                      {currentUser.permissions.commons.production_model
                        .delete && (
                        <Button
                          onClick={(e) => {
                            dialogControl.deletionConfirm(
                              model.name,
                              (argee) => {
                                if (argee) {
                                  return restRequest(
                                    `commons/production_models/${model.id}`,
                                    null,
                                    "delete"
                                  ).then(() => {
                                    setSearchData((searchData: any) => ({
                                      ...searchData,
                                      refresh: (searchData.refresh || 1) + 1,
                                    }));
                                  }).catch(e => {
                                    
                                  });
                                }
                                return Promise.resolve();
                              }
                            );
                          }}
                          color="red"
                          icon="delete"
                          size="mini"
                        />
                      )}

                      <Button
                        title="Journalization"
                        onClick={(e) => {
                          e.preventDefault();
                          journalizationModalControl.data = model.id;
                          journalizationModalControl.setOpen(true);
                        }}
                        icon="history"
                        size="mini"
                      ></Button>
                    </td>
                  </tr>
                );
              })}
            </Table.Body>
          </Table>
          <Page data={models} updatePage={setSearchData}></Page>
        </Segment>
      </Segment.Group>

      <Editor
        id={currentEditId}
        area_id={props.area_id}
        modelControl={editModalControl}
        onFinish={(result) => {
          setSearchData((searchData: any) => ({
            ...searchData,
            refresh: (searchData.refresh || 1) + 1,
          }));
          editModalControl.setOpen(false);
          setReloadNumber((n) => n + 1);
        }}
      ></Editor>

      {journalizationModalControl.data > 0 && <Journalization modalControl={journalizationModalControl} />}
    </>
  );
}

function Journalization(props: { modalControl: ModalControlData<number> }) {
  return (
    <Modal {...props.modalControl.props}>
      <Modal.Header>Journalization</Modal.Header>
      <Modal.Content>
        <JournalizationComponent
          containerId={props.modalControl.data}
          containerType={5}
          detailFields={[
            { key: "name", name: "Name" },
            { key: "description", name: "Description" },
          ]}
        />
      </Modal.Content>
    </Modal>
  );
}

function Editor(props: {
  id?: number;
  area_id: number;
  modelControl: ModalControlData;
  onFinish: (data: ModelData) => void;
}) {
  const { id, area_id, modelControl, onFinish } = props;
  const isCreate = !id;

  const [data, setField, setData] = useFormData<ModelData>({} as any);
  const [invalidError, setInvalidError] = useState<any>({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setData({ admin: false } as any);
    setInvalidError({});
    if (id) {
      setLoading(true);
      restRequest<ModelData>("commons/production_models/" + id)
        .then(setData)
        .finally(() => setLoading(false));
    } else {
      setData((d) => ({ ...d, area_id }));
    }
  }, [id]);

  const onSubmit = (
    event: React.FormEvent<HTMLFormElement>,
    formProps: FormProps
  ) => {
    event.stopPropagation();
    event.preventDefault();

    setLoading(true);

    restRequest<ModelData>(
      `commons/production_models${isCreate ? "" : "/" + id}`,
      data,
      isCreate ? "post" : "put"
    )
      .then(
        (result) => {
          props.onFinish(result);
          setInvalidError({});
        },
        (resp) => {
          if (resp.status === 2) {
            setInvalidError(resp.data);
          }
        }
      )
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Modal {...props.modelControl.props} size="large">
        <Modal.Header>
          {isCreate ? "Create" : "Update"} Production Model{" "}
        </Modal.Header>
        <Modal.Content>
          <Form onSubmit={onSubmit} loading={loading}>
            <Form.Group widths="equal">
              <Form.Input
                label="Name"
                name="name"
                value={data["name"] || ""}
                onChange={setField}
                required
                error={fieldError("name", invalidError)}
              ></Form.Input>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Input
                label="Description"
                error={fieldError("description", invalidError)}
              >
                <TextArea
                  name="description"
                  value={data.description || ""}
                  onChange={setField}
                />
              </Form.Input>
            </Form.Group>
            <div>
              <Button primary>Submit</Button>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <Button as="a" onClick={(e) => props.modelControl.setOpen(false)}>
                Cancel
              </Button>
            </div>
          </Form>
        </Modal.Content>
      </Modal>
    </>
  );
}

export function ProductionModelDropdown(props: {
  area_id: number;
  name: string;
  label: any;
  value: any;
  onChange: (
    event: React.SyntheticEvent<HTMLElement, Event>,
    data: DropdownProps
  ) => void;
  required?: boolean;
  error?: any;
}) {
  const { area_id, name, label, onChange, required, error } = props;
  const [options, setOptions] = useState<DropdownItemProps[]>();
  const [refreshModels, setRefreshModels] = useState<number>(0);
  const modelModalControl = useModalControl();

  let value = props.value;
  if (options && !options.find((o) => o.value === value)) {
    const existInOption = options.find(
      (o) =>
        o.value && (o.value as string).toUpperCase() === value.toUpperCase()
    );
    if (existInOption) {
      value = existInOption.value;
    }
  }

  useEffect(() => {
    if (!_.isNull(area_id) && !_.isUndefined(area_id)) {
      restRequest<DropdownItemProps[]>(
        `commons/production_models/${area_id}/search_for_selection`
      ).then((options) => {
        setOptions([
          ...(!required ? [{ key: "", text: "", value: "" }] : []),
          ...options,
        ]);
      });
    }
  }, [area_id, refreshModels, required]);

  return (
    <>
      <Form.Input
        label={
          <>
            <label style={{ display: "inline-block", marginRight: "1rem" }}>
              {label}
            </label>{" "}
            <Button
              onClick={(e) => modelModalControl.setOpen(true)}
              compact
              color="blue"
              icon="edit outline"
              size="mini"
              as="a"
            ></Button>
          </>
        }
        required={required || false}
        error={error}
      >
        <Dropdown
          name={name}
          value={value || ""}
          onChange={onChange}
          options={options || []}
          search
          selection
          fluid
          allowAdditions
        ></Dropdown>
      </Form.Input>

      <Modal
        open={modelModalControl.props.open}
        onClose={() => {
          modelModalControl.props.onClose();
          setRefreshModels((n) => n + 1);

          $(window).trigger(`refresh_production_model_${area_id}`);
        }}
        size="large"
        closeIcon="close"
      >
        <Modal.Header> {label} </Modal.Header>
        <Modal.Content>
          <ProductionModelComponent area_id={area_id} />
        </Modal.Content>
      </Modal>
    </>
  );
}

export function ProductionModelSearchDropdown(props: {
  area_id: number;
  name: string;
  placeholder?: string;
  value: any;
  additionValues?: DropdownItemProps[];
  onChange: (
    event: React.SyntheticEvent<HTMLElement, Event>,
    data: DropdownProps
  ) => void;
}) {
  const { area_id, name, placeholder, onChange, additionValues } = props;
  const [options, setOptions] = useState<DropdownItemProps[]>([
    { key: "all", text: "All", value: "", isAdded: true },
    ...(additionValues || []).map((v) => ({
      ...v,
      isAdded: true,
      preserver: true,
    })),
  ]);
  const [refreshModels, setRefreshModels] = useState<number>(0);

  let value = props.value;
  if (options && !options.find((o) => o.value === value)) {
    const existInOption = options.find(
      (o) =>
        o.value && (o.value as string).toUpperCase() === value.toUpperCase()
    );
    if (existInOption) {
      value = existInOption.value;
    }
  }

  useEffect(() => {
    if (!_.isNull(area_id) && !_.isUndefined(area_id)) {
      restRequest<DropdownItemProps[]>(
        `commons/production_models/${area_id}/search_for_selection?refresh=${refreshModels}`
      ).then((options) => {
        setOptions((originalOptions) => {
          return [...originalOptions.filter((o) => o.isAdded), ...options];
        });
      });
    }
  }, [area_id, refreshModels]);

  useEffect(() => {
    const onRefresh = () => {
      setRefreshModels((n) => n + 1);
    };
    $(window).on(`refresh_production_model_${area_id}`, onRefresh);

    return () => {
      $(window).off(`refresh_enum_data_${area_id}`, onRefresh);
    };
  }, [area_id]);

  useEffect(() => {
    if (placeholder) {
      setOptions((os) => [
        { key: "all", text: `${placeholder}: All`, value: "", isAdded: true },
        ...(additionValues || []).map((v) => ({
          ...v,
          isAdded: true,
          preserver: true,
        })),
        os.slice(1).filter((v) => !v.preserver),
      ]);
    } else {
      setOptions((os) => [
        { key: "all", text: "All", value: "", isAdded: true },
        ...(additionValues || []).map((v) => ({
          ...v,
          isAdded: true,
          preserver: true,
        })),
        os.slice(1).filter((v) => !v.preserver),
      ]);
    }
  }, [placeholder, (additionValues || []).map((v) => v.value).join("_,")]);

  return (
    <Dropdown
      name={name}
      value={value || ""}
      placeholder={placeholder}
      onChange={onChange}
      options={options || []}
      search
      selection
      allowAdditions
      onAddItem={(e, d) => {
        setOptions((os) => [
          os[0],
          {
            key: d.value,
            text: d.value as string,
            value: d.value as string,
            isAdded: true,
          },
          ...os.slice(1),
        ]);
      }}
      className="mini"
    ></Dropdown>
  );
}
